import React from "react";
import { FaTimes, FaCog } from "react-icons/fa";

const ReelDurationModal = ({
  isOpen,
  onClose,
  reelDuration,
  setReelDuration,
  isFreeModel,
  reelDurationError,
  selectedAIModel = null,
  resolution = null,
  setResolution = null,
  isPreview = false,
  className = ""
}) => {
  if (!isOpen && !isPreview) return null;

  // Duration options: default is [4, 6, 8], but add 10s for minimax_hailuo-2.3-fast
  const isMinimaxHailuoFast = selectedAIModel === 'minimax_hailuo-2.3-fast';
  const durationOptions = isMinimaxHailuoFast ? [6, 10] : [4, 6, 8];

  const Panel = (
    <div className="glass-effect rounded-2xl border border-white/10 bg-[#111111]/95 backdrop-blur-2xl p-4 w-72 sm:w-80">
      <div className="flex items-center gap-2 mb-2">
        <FaCog className="text-amber-300/90 text-xs" />
        <h3 className="text-xs font-medium text-white">Video duration</h3>
        {!isPreview && (
          <button type="button" className="ml-auto text-gray-300 hover:text-white" onClick={onClose}>
            <FaTimes className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
      <div className="flex gap-2">
        {durationOptions.map(d => {
          // For minimax_hailuo-2.3-fast: 10s is only available for 768p resolution
          const is10sDisabled = (d === 10 && isMinimaxHailuoFast && resolution !== '768p');
          const isDisabled = is10sDisabled;
          const isActive = reelDuration === d;
          return (
            <div key={d} className="flex flex-col items-start relative group">
              <button
                type="button"
                disabled={isDisabled}
                className={`px-2 py-1 rounded-full border text-[11px] ${isActive ? 'bg-white/10 text-white border-white/20' : 'text-gray-300 border-gray-600/40'} ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={!isDisabled ? () => { 
                  setReelDuration(d); 
                  // Auto-switch to 768p if 10s is selected for minimax_hailuo-2.3-fast
                  if (d === 10 && isMinimaxHailuoFast && resolution !== '768p' && setResolution) {
                    setResolution('768p');
                  }
                  if (!isPreview) onClose(); 
                } : undefined}
                title={isDisabled ? '10 seconds is only available for 768p resolution' : `${d}s`}
              >
                {`${d}s`}
              </button>
              {is10sDisabled && (
                <div className="absolute bottom-full left-0 mb-2 hidden group-hover:block z-50 pointer-events-none">
                  <div className="rounded-lg border border-white/10 bg-[#111111]/95 backdrop-blur-2xl px-2.5 py-1.5 shadow-2xl max-w-[16rem] text-[10px] leading-snug text-white relative">
                    <div className="font-medium mb-0.5">10s Not Available</div>
                    <div className="text-gray-300">10 seconds is only available for 768p resolution.</div>
                    <div className="absolute left-3 -bottom-0.5 w-1.5 h-1.5 bg-[#111111]/95 border border-white/10 rotate-45"></div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {/* <div className="mt-1 text-[10px] text-gray-300">Longer videos coming soon!</div> */}
      {reelDurationError && <div className="mt-1 text-[10px] text-red-400">{reelDurationError}</div>}
    </div>
  );

  if (isPreview) return <div className={`absolute z-50 pointer-events-auto ${className}`}>{Panel}</div>;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      {Panel}
    </div>
  );
};

export default ReelDurationModal; 